import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link as RouterLink } from 'react-router-dom';
import moment from 'moment';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import Backdrop from '@mui/material/Backdrop';
import { useLawyerContext } from '../../context/lawyer-info-context';
import LawyerImg from '../../assets/laywer2.jpg';

export default function Lawyer(): JSX.Element {
  const { t } = useTranslation();

  const lawyer = useLawyerContext();

  return (
    <div>
      <Box
        component="section"
        sx={{
          position: 'relative',
          height: { xs: '600px', sm: '556px', md: '740px', lg: '924px', xl: '1400px' },
          backgroundImage: `url(${LawyerImg})`,
          backgroundRepeat: 'no-repeat',
          backgroundSize: 'contain',
          backgroundPosition: 'center top',
        }}
      >
        <Backdrop
          open
          sx={{ position: 'absolute', zIndex: 0, backgroundColor: 'rgba(0, 0, 0, 0.1)' }}
        />
      </Box>
      <Box sx={{ backgroundColor: (theme) => theme.palette.grey['300'] }}>
        <Container
          maxWidth="xl"
          sx={{
            position: 'relative',
            height: '100%',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'flex-start',
          }}
        >
          <Box sx={{ py: { xs: 6 }, px: { xs: 1, sm: 3 } }}>
            <Box sx={{ overflow: 'auto' }}>
              <Typography variant="h4" align="center" gutterBottom>
                {t('lawyerTitle')}
              </Typography>
              <Typography variant="h3" align="center" gutterBottom>
                {t(lawyer.fullName)}
              </Typography>
              <Typography variant="h5" align="center" gutterBottom>
                {t(lawyer.experienceYears, {
                  count: moment().year() - 2010,
                })}
              </Typography>
              <Typography align="center" sx={{ mt: 3 }}>
                <Button
                  component={RouterLink}
                  to="/about"
                  variant="contained"
                  color="primary"
                  size="large"
                >
                  {t('buttons.more')}
                </Button>
              </Typography>
            </Box>
          </Box>
        </Container>
      </Box>
    </div>
  );
}
